'use client';

import { usePathname } from 'next/navigation';
import { type Locale, DEFAULT_LOCALE } from '@/lib/i18n';

const LOCALES = ['en', 'es', 'pt', 'de', 'fr'] as const;

// Read the current locale from the URL. Pathname always reflects the
// user-facing URL (not the rewritten one), so `/es/pricing` returns 'es'
// even though the server rendered `/pricing` internally.
export function useLocale(): Locale {
    const pathname = usePathname() || '/';
    const seg = pathname.split('/', 2)[1];
    if ((LOCALES as readonly string[]).includes(seg)) return seg as Locale;
    return DEFAULT_LOCALE;
}
